import { ds } from "js/core/models/dataService";
import { Backbone } from "js/vendor";
import Logger from "js/core/logger";
import { app } from "js/namespaces";
import { FeatureType, getUserPlanPermissions, getUserOrgPermissions } from "./planPermissions";
import { getFeatures } from "common/features";

const Features = Backbone.Model.extend({
    defaults: {
        permissions: Object.freeze({}),
        prevOrgId: null,
        prevTeam: null,
    },

    initialize: function() {
        // TODO(john): Q: why would this change? if the user upgrades their plan?
        // TODO(john): Q: if the user joins or leaves a team or changes role on a team, we need to update this
        this.listenTo(ds.userPlans, "change", this.loadUserPlanPermissions);
        this.listenTo(app.appState, "change", () => {
            let orgId = app.appState.orgId;
            if (this.prevOrgId !== orgId) {
                let team = orgId ? app.appState.currentTeam : null;
                if (this.prevTeam) {
                    this.stopListening(this.prevTeam, "change");
                }
                if (team) {
                    // We listen for updates to the team model so we can update the settings
                    this.listenTo(team, "change", this.loadUserPlanPermissions);
                } else {
                    // Ensure that we update the permissions when switching to personal workspaces
                    this.loadUserPlanPermissions();
                }
                this.prevOrgId = orgId;
                this.prevTeam = team;
            }
        });
    },

    async loadUserPlanPermissions() {
        // Fully load the new permissions map before assigning
        //   so we can avoid race conditions while loading
        let permissions = {};
        permissions["personal"] = await getUserPlanPermissions();

        //ds.teams does not exist for cypress test users
        if (ds.teams && app.user.has("orgs")) {
            for (const orgId of Object.keys(app.user.get("orgs"))) {
                permissions[orgId] = await getUserOrgPermissions(orgId);
            }
        }

        this._permissions = permissions;
    },

    // TODO: if these were persisted we'd fetch them in the usual manner
    async loadFakeElectronUserPlanPermissions() {
        this._permissions = {};
        this._permissions["personal"] = getFeatures("pro");

        if (ds.teams && app.user.has("orgs")) {
            for (const orgId of Object.keys(app.user.get("orgs"))) {
                this._permissions[orgId] = getFeatures("member-licensed");
            }
        }
    },

    isFeatureEnabled(feature, workspaceId) {
        if (workspaceId === undefined) {
            throw new Error("missing workspaceId");
        }
        const rv = this._getWorkspaceFeatures(workspaceId).hasOwnProperty(feature);
        return rv;
    },

    getFeatureProps(feature, workspaceId) {
        if (workspaceId === undefined) {
            throw new Error("missing workspaceId");
        }
        const featureProps = this._getWorkspaceFeatures(workspaceId)[feature];
        if (!featureProps) {
            Logger.warn(`${feature} planPermission does not exist for current user. Please check if the ${feature} planPermission is attached to the plan.`);
        }
        return featureProps || {};
    },

    /** @private */
    _getWorkspaceFeatures(workspaceId) {
        if (workspaceId === undefined) {
            throw new Error("missing workspaceId");
        }
        // presentations from external workspaces go into the personal workspace
        const features = this._permissions[workspaceId];
        if (!features) {
            return this._permissions["personal"];
        }
        return features;
    }
});

export { Features, FeatureType };
